<template>
  <div class="prePay">
    <p>预交费</p>
    <van-cell-group>
      <van-field v-model="orderDetails.needPay" label="预交费金额(元)" type="number" placeholder="0" input-align="right" />
      <van-cell v-if="payChanel==8" title="支付方式" is-link :value="payWayStr" @click="showPopup" :label="'余额：￥'+userAccount.balanceRecharge" />
      <van-cell v-if="payChanel==14" title="支付方式" is-link :value="payWayStr" @click="showPopup" />
    </van-cell-group>
    <van-button v-if="payBtShow" class="bt-qurey" color="#f47b20" @click="goPay">确认缴费</van-button>
    <van-button v-if="notPayBtShow" class="bt-qurey" color="#aaaaaa">该停车场不支持线上缴费</van-button>
      <van-popup class="pay-popup" v-model="show" position="bottom">
      <van-radio-group v-model="payChanel" v-if="payWayList.length>0">
        <van-cell-group v-for="item in payWayList" :key="item.value">
          <van-cell :title="item.name" :icon="item.icon" clickable @click="changePayWay(item.value)">
            <template #right-icon>
              <van-radio :name="item.value" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-popup>
    <van-popup class="loading-popup" v-model="IsLoading">
      <van-loading  size="24px" color="#FFF" vertical>余额支付</van-loading>
    </van-popup>
  </div>
</template>
<script>
import { mySessionStorage } from '@/utils/storage.js'
export default {
  name: "prePay",
  data() {
    return {
      title: "",
      active: "2",
      carNum: "",
      value:"",
      show:false,
      payChanel:"14",
      companyId:"",
      payWayStr:"微信支付",
      payWayList:[],
      IsLoading:false,
      payBtShow:true,
      notPayBtShow:false,
      userAccount:"",
      orderDetails:{
        shouldPay:"",
        needPay:"",
        parkingTime:"",
        startTime:"",
        parkName:"",
        orderId:"",
        type:"",
        carNum:"",
        companyId:""
      },
    };
  },
  methods: {
        //发起支付
    goPay() {
      console.log(this.payChanel);
	  let needPay = this.orderDetails.needPay;
      if(needPay==''||needPay<=0||needPay>1000){
        this.$toast("预缴费金额范围为0~1000,请重新输入");
        return;
      }
      if(this.payChanel=='8'){
        if(this.userAccount.balanceRecharge<needPay){
          this.$toast("余额不足");
          return;
        }
        this.IsLoading=true;
      }    
      console.log(this.orderDetails.orderId);
      let params = {
        carNum: this.carNum,
        orderId: this.orderDetails.orderId,
        payWay:2,//微信或小程序支付
        payChanel:this.payChanel,//[8:余额支付；14:w微信支付]
        payLevel:0,//预缴费
        openid:this.openid,
        payMoney:needPay,
        type:this.orderDetails.type
      };
      console.log(JSON.stringify(params));
        this.$http
        .post(this.$api.wxPubPay, params)
        .then(res => {
          if (res.code == 200) {
            switch (this.payChanel) {
              case "8"://余额支付
                this.IsLoading=false
                this.goPayResult(1);
                break;
              case "14"://微信支付
                var opthions = JSON.parse(res.data);
                console.log(opthions);
                this.$WXjsSDK(opthions,"预交费成功","pay");
               break;
            }
          } 
          else {
            switch (this.payChanel) {
              case "8"://余额支付
                this.IsLoading=false
                this.goPayResult(0);
                break;
              case "14"://微信支付
                this.$toast("发起支付失败，请稍后再试");
                break;
            }
           
          }

        })
        .catch(err => {
          switch (this.payChanel) {
              case "8"://余额支付
                this.IsLoading=false
                this.goPayResult(0);
                break;
              case "14"://微信支付
                this.$toast("发起支付失败，请稍后再试");
                break;
            }
        });

    },
    showPopup() {
      this.show = true;
    }, 
    getOrderDetails(){
      this.orderDetails=this.$route.query.orderInfo;
      this.companyId=this.orderDetails.companyId;
      this.carNum=this.orderDetails.carNum;
      console.log(this.orderDetails);
    },
    //切换支付方式
    changePayWay(type){
      this.payChanel=type+"";
      if(type==8){
        this.payWayStr='余额支付';
        if(this.userAccount.balanceRecharge<this.orderDetails.needPay){
          this.$toast("余额不足");
          return;
        }
      }
      if(type==14){
        this.payWayStr='微信支付';
      }
     this.show=false;

    }, 


        //获取该订单停车场支持的线上缴费方式
    getSupportPayWay() {
      let params = {
        companyId: this.companyId,
      };
      this.$http
        .post(this.$api.getpayWayList, params)
        .then(res => {
          console.log("缴费方式:", res);
          if (res.code == 200) {
            this.payWayList=res.data;
            if (this.payWayList.length == 0) {
              this.payBtShow = false;
              this.notPayBtShow = true;
            }
            if(this.payWayList.length == 1){
            this.payChanel=this.payWayList[0].value;
            this.payWayStr=this.payWayList[0].name;
            }
          }
          else{
            this.payBtShow = false;
            this.notPayBtShow = true;
          }
        })
        .catch(err => {
          this.payBtShow = false;
          this.notPayBtShow = true;
          console.log(err);
        });
    },
    //获取用户余额
    getUserBalance() {
      let params = {
        openid: this.openid,
      };
      this.$http
        .post(this.$api.getUserBalance, params)
        .then(res => {
          console.log("余额信息:", res);
          if (res.code == 200) {
            this.userAccount=res.data;
            this.payChanel="8";
            this.payWayStr="余额支付";
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //跳转到支付结果页
    goPayResult(result){
      this.$router.push(
        {
          name:"payResult",
          query:{
            result:result,
            msg:"预缴费成功"
          }
        }
        );
    },
  },
  created() {
   
  },
  mounted(){
    this.openid=mySessionStorage.getItem("openid");
    this.getOrderDetails();
    this.getUserBalance();
    this.getSupportPayWay();
  }
};
</script>

<style scoped>
.prePay {
  min-height: 100%;
  height: 100%;
  width: 100%;
  max-width: 100%;
  background-color: #FFFFFF;
  float: left;
}
.prePay p{
    text-align: center;
    font-size: 20px;
    color: #f47b20;
}
.van-cell-group{
    width: 90%;
    margin-left: 5%;
}
.bt-qurey {
  width: 90%;
  margin-left: 5%;
  margin-top: 16px;
  border-radius: 5px;
  height: 36px;
  /* position: fixed;
  display: block; */
}
.pay-popup{
    width: 100%;
    height: 20%;
}
.loading-popup{
  height: 75px;
  width: 100px;
  padding-top: 25px;
  border-radius: 10px;
  background-color: #333;
}
.van-icon-wechat::before{
    color: green;
}
.van-icon-balance-o::before{
    color: #f47b20;
}
</style>



// WEBPACK FOOTER //
// src/components/order/prePay.vue